/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
(function customFlickityCounter(root) {
  root = root || document;

  var widgets = [].slice.call(root.querySelectorAll('[data-mobile-dots]'));
  if (!widgets.length) return;

  widgets.forEach(setupCounter);

  function setupCounter(wrap) {
    var counterEl = wrap.querySelector('.product__mobile-dots-counter');
    var dotsContainer = wrap.querySelector('.flickity-page-dots');
    if (!counterEl || !dotsContainer) return;

    var dots = [].slice.call(dotsContainer.querySelectorAll('[data-mobile-dot]'));
    var total = dots.length;
    if (!total) return;

    function selectedIndex() {
      var idx = dots.findIndex(function (d) { return d.classList.contains('is-selected'); });
      return idx >= 0 ? idx : 0;
    }

    function update(i) {
      if (i < 0) i = 0;
      if (i >= total) i = total - 1;
      counterEl.textContent = (i + 1) + '/' + total;
    }
    update(selectedIndex());

    dots.forEach(function (btn, idx) {
      btn.addEventListener('click', function () { update(idx); });
    });

    var mo = new MutationObserver(function () { update(selectedIndex()); });
    mo.observe(dotsContainer, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})(document);

document.addEventListener("DOMContentLoaded", function() {
  let selectBtn = document.getElementById("select-size-btn");
  let variantContainer = document.getElementById("variant-container");

  if (selectBtn && variantContainer) {
    selectBtn.addEventListener("click", function(event) {
      event.preventDefault();
      selectBtn.style.display = "none";        
      variantContainer.classList.remove("hidden");
    });
  }

  // Sort filter functionality
  function initSortFilter() {
    const sortButtonText = document.querySelector('[data-sort-button-text]');
    const sortContainer = document.querySelector('.popout--sort');
    
    if (!sortButtonText || !sortContainer) return;

    function updateButtonText(text) {
      sortButtonText.textContent = `(${text})`;
    }

    function updateSortState() {
      const sortBy = new URLSearchParams(window.location.search).get('sort_by');
      const popout = sortContainer.querySelector('.popout');
      
      // Remove is-active class from all items first
      sortContainer.querySelectorAll('.popout-list__item').forEach(item => {
        item.classList.remove('is-active');
      });
      
      if (!sortBy) {
        // No sort selected - remove is-active class and reset button text
        popout.classList.remove('is-active');
        sortButtonText.textContent = '';
        return;
      }

      const sortOption = document.querySelector(`[data-sort-link][data-value="${sortBy}"]`);
      if (sortOption) {
        popout.classList.add('is-active');
        updateButtonText(sortOption.textContent.trim());
        sortOption.closest('.popout-list__item')?.classList.add('is-active');
      }
    }

    // Event delegation for sort links
    sortContainer.addEventListener('click', (e) => {
      const sortLink = e.target.closest('[data-sort-link]');
      if (sortLink) {
        updateButtonText(sortLink.textContent.trim());
      }
    });

    window.addEventListener('popstate', updateSortState);
    updateSortState();
  }

  // Initialize and reinitialize on section load
  initSortFilter();
  document.addEventListener('shopify:section:load', initSortFilter);
});
  class HeaderState {
    constructor() {
      this.header = document.querySelector('header-component');
      this.drawerBody = document.querySelector('.drawer__body');
      this.announcementBar = document.querySelector('announcement-bar');
      this.isStuck = false;
      this.isMobile = window.innerWidth < 750;

      this.init();
    }

    init() {
      if (!this.header || !this.drawerBody || !this.isMobile) return;

      this.updateState();
      this.updateDrawerMargin();

      this.observer = new MutationObserver(() => {
        if (!this.isMobile) return;
        this.updateState();
        this.updateDrawerMargin(); 
      });
      
      this.observer.observe(this.header, {
        attributes: true,
        attributeFilter: ['class']
      });

      window.addEventListener('scroll', () => {
        if (!this.isMobile) return;
        this.updateState();
        this.updateDrawerMargin();
      });

      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 750;
        if (!this.isMobile) {
          this.drawerBody.style.marginTop = '0px';
          return;
        }
        this.updateState();
        this.updateDrawerMargin();
      });
    }

    updateState() {
      if (!this.isMobile) return;
      this.isStuck = this.header.classList.contains('js__header__stuck');
    }

    getAnnouncementBarHeight() {
      if (!this.announcementBar || !this.isMobile) return 0;
      
      if (this.isStuck) return 0;
      
      const rect = this.announcementBar.getBoundingClientRect();
      return rect.height;
    }

    updateDrawerMargin() {
      if (!this.isMobile) return;
      const announcementHeight = this.getAnnouncementBarHeight();
      const baseMargin = 0;
      const totalMargin = baseMargin + announcementHeight;
      
      this.drawerBody.style.marginTop = `${totalMargin}px`;
    }
  }
  new HeaderState();


  function signupForWaitlist() {
    const signupButton = document.querySelector('.btn-waitlist');
    if (!signupButton || signupButton.dataset.waitlistInitialized === 'true') return;
  
    const signupModal = document.querySelector('.product__waitlist_modal');
    const releaseName = signupButton.dataset.releaseName;
    
    if (!signupModal) {
      console.warn('Waitlist modal not found');
      return;
    }

    const signupSubmit = signupModal.querySelector('.product__waitlist_modal-submit');
    const errorField = signupModal.querySelector('.error-field');
    const successField = signupModal.querySelector('.success-field');
  
    if (!signupSubmit || !errorField || !successField) {
      console.warn('Required waitlist modal elements not found');
      return;
    }

    signupButton.dataset.waitlistInitialized = 'true';
  
    signupButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (signupModal) {
        signupModal.classList.add('active');
      }
    });
  
    signupSubmit.addEventListener('click', (e) => {
      e.preventDefault();
      
      const emailInput = signupModal.querySelector("input[type='email']");
      if (!emailInput) {
        console.error('Email input not found');
        return;
      }
      
      const email = emailInput.value.trim();
      errorField.innerHTML = '';
      successField.innerHTML = '';
  
      // Validate email
      if (!email || !email.includes('@') || !email.includes('.')) {
        errorField.innerHTML = window.theme?.strings?.waitlist_email_error || 'Please enter a valid email address';
        return;
      }
  
      if (!releaseName) {
        errorField.innerHTML = window.theme?.strings?.waitlist_error || 'Release name not found';
        return;
      }
  
      // Disable submit button and show loading state
      signupSubmit.classList.add('disabled');
      const originalText = signupSubmit.innerHTML;
      signupSubmit.innerHTML = window.theme?.strings?.waitlist_submitting || 'Submitting...';
      signupSubmit.disabled = true;
  
      // Get product information
      const productTitle = document.querySelector('.main-product__title')?.innerText?.trim() || 
                          document.querySelector('h1')?.innerText?.trim() || 
                          'Product';
      const productId = document.querySelector('.product__release')?.getAttribute('data-product-id') || 
                       document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
  
      const subscribePayload = {
        email,
        releaseName,
        productId: productId,
        productTitle: productTitle,
      };
  
      fetch(`https://planetnusa-backend-323660974935.europe-west1.run.app/api/waitlist/signup`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(subscribePayload),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(() => {
          successField.innerHTML = window.theme?.strings?.waitlist_success || 'Successfully signed up for waitlist!';
          emailInput.value = ''; // Clear the email input
        })
        .catch((error) => {
          console.error('Waitlist signup error:', error);
          errorField.innerHTML = window.theme?.strings?.waitlist_error || 'An error occurred. Please try again.';
        })
        .finally(() => {
          // Re-enable submit button
          signupSubmit.classList.remove('disabled');
          signupSubmit.innerHTML = originalText;
          signupSubmit.disabled = false;
        });
    });
  
  }
  
  function signupModalClose() {
    const signupModal = document.querySelector('.product__waitlist_modal');
    if (!signupModal || signupModal.dataset.waitlistCloseInitialized === 'true') return;

    signupModal.dataset.waitlistCloseInitialized = 'true';

    const signupCloseButton = signupModal.querySelector('.close');
    const signupOverlay = signupModal.querySelector('.product__waitlist_modal-overlay');
  
    const closeModal = () => {
      signupModal.classList.remove('active');
    };

    // Close button
    if (signupCloseButton) {
      signupCloseButton.addEventListener('click', closeModal);
    }

    // Overlay click
    if (signupOverlay) {
      signupOverlay.addEventListener('click', closeModal);
    }

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && signupModal.classList.contains('active')) {
        closeModal();
      }
    });
  }
  
  // Initialize coming soon functionality
  signupModalClose();
  signupForWaitlist();

  document.addEventListener('theme:product:color-change', () => {
    signupModalClose();
    signupForWaitlist();
  });

  const backInStockFallback = {
    account: 'XcTGga',
    list: 'UTaHQC',
    modal: null,
    trigger: null,
    variant: null,
    product: null,

    productComponent() {
      return document.querySelector('main product-component');
    },

    productData(component) {
      const productJSON = component?.querySelector('[data-product-json]');
      if (!productJSON) return null;

      try {
        return JSON.parse(productJSON.textContent);
      } catch (error) {
        return null;
      }
    },

    selectedVariant(component) {
      const product = this.productData(component);
      const selectors = component?.querySelector('[data-product-variants]');
      if (!product || !selectors) return null;

      try {
        const selectedOptions = {};
        selectors.querySelectorAll('[data-single-option-selector]').forEach((input) => {
          if ((input.matches('input') && !input.checked) || (input.matches('option') && !input.selected)) return;
          selectedOptions[input.dataset.index] = input.value;
        });

        return product.variants.find((variant) => variant.options.every((option, index) => {
          return selectedOptions[`option${index + 1}`] === option;
        })) || null;
      } catch (error) {
        return null;
      }
    },

    ensureModal() {
      if (this.modal?.isConnected) return;

      const modal = document.createElement('div');
      modal.className = 'planet-nusa-bis-modal';
      modal.hidden = true;
      modal.innerHTML = `
        <div class="planet-nusa-bis-modal__overlay" data-bis-close></div>
        <div class="planet-nusa-bis-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="planet-nusa-bis-title">
          <button class="planet-nusa-bis-modal__close" type="button" aria-label="Close" data-bis-close>&times;</button>
          <h2 id="planet-nusa-bis-title"></h2>
          <p>Register to receive a notification when this item comes back in stock.</p>
          <form class="planet-nusa-bis-modal__form">
            <div class="planet-nusa-bis-modal__variants">
              <select id="planet-nusa-bis-variant" aria-label="Size"></select>
            </div>
            <label for="planet-nusa-bis-email">Email</label>
            <input id="planet-nusa-bis-email" type="email" autocomplete="email" required>
            <label class="planet-nusa-bis-modal__newsletter" for="planet-nusa-bis-newsletter">
              <input id="planet-nusa-bis-newsletter" type="checkbox">
              <span>Yes, I agree to Planet Nusa ApS contacting me by email with news and offers. I can withdraw consent anytime.</span>
            </label>
            <p class="planet-nusa-bis-modal__error" role="alert" hidden></p>
            <p class="planet-nusa-bis-modal__success" role="status" hidden>You're in! We'll let you know when it's back.</p>
            <button class="btn btn--solid btn--primary" type="submit">Join the waitlist</button>
          </form>
        </div>`;
      document.body.append(modal);

      modal.addEventListener('click', (event) => {
        if (event.target.closest('[data-bis-close]')) this.closeModal();
      });
      modal.querySelector('form').addEventListener('submit', (event) => this.submit(event));
      this.modal = modal;
    },

    openModal(trigger) {
      const component = trigger.closest('product-component');
      this.product = this.productData(component);
      this.variant = this.selectedVariant(component);
      if (!this.variant || this.variant.available) return;
      this.ensureModal();
      this.trigger = trigger;
      this.modal.querySelector('#planet-nusa-bis-title').textContent = this.product.title;
      const unavailableVariants = this.product.variants.filter((variant) => !variant.available);
      const variantWrapper = this.modal.querySelector('.planet-nusa-bis-modal__variants');
      const variantSelect = this.modal.querySelector('#planet-nusa-bis-variant');
      variantSelect.replaceChildren(...unavailableVariants.map((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        option.selected = variant.id === this.variant.id;
        return option;
      }));
      variantWrapper.hidden = unavailableVariants.length === 1;
      this.modal.hidden = false;
      document.documentElement.classList.add('planet-nusa-bis-open');
      this.modal.querySelector('input[type="email"]').focus();
    },

    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.documentElement.classList.remove('planet-nusa-bis-open');
      this.trigger?.focus();
    },

    async submit(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const email = form.querySelector('input[type="email"]').value.trim();
      const variantId = form.querySelector('#planet-nusa-bis-variant').value;
      const subscribeToNewsletter = form.querySelector('#planet-nusa-bis-newsletter').checked;
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('.planet-nusa-bis-modal__error');
      const success = form.querySelector('.planet-nusa-bis-modal__success');
      error.hidden = true;
      success.hidden = true;
      button.disabled = true;

      try {
        const requests = [fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.account}`, {
          method: 'POST',
          headers: {
            revision: '2024-02-15',
            'Content-Type': 'application/json',
            'X-Klaviyo-Onsite': '1'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } }
              }
            }
          })
        })];
        if (subscribeToNewsletter) {
          requests.push(fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.account}`, {
            method: 'POST',
            headers: {
              revision: '2024-02-15',
              'Content-Type': 'application/json',
              'X-Klaviyo-Onsite': '1'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email, properties: { $source: 'Back in Stock' } } } }
                },
                relationships: { list: { data: { type: 'list', id: this.list } } }
              }
            })
          }));
        }
        const responses = await Promise.all(requests);
        if (responses.some((response) => !response.ok)) throw new Error('Back in stock subscription failed');
        success.hidden = false;
        form.querySelector('input[type="email"]').value = '';
      } catch (requestError) {
        error.textContent = 'An error occurred. Please try again.';
        error.hidden = false;
      } finally {
        button.disabled = false;
      }
    },

    update() {
      const component = this.productComponent();
      if (!component) return;
      const productForm = component.querySelector('form[data-product-form]');
      if (!productForm) return;

      const nativeTrigger = productForm.querySelector('.klaviyo-bis-trigger');
      let fallbackTrigger = productForm.querySelector('.planet-nusa-bis-trigger');
      if (nativeTrigger) {
        fallbackTrigger?.remove();
        return;
      }

      if (!fallbackTrigger) {
        fallbackTrigger = document.createElement('button');
        fallbackTrigger.type = 'button';
        fallbackTrigger.className = 'btn btn-bis planet-nusa-bis-trigger';
        fallbackTrigger.textContent = 'Join the waitlist';
        productForm.append(fallbackTrigger);
      }

      const variant = this.selectedVariant(component);
      fallbackTrigger.hidden = !variant || variant.available;
    }
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest('main product-component [data-product-variants]')) return;
    [0, 100].forEach((delay) => window.setTimeout(() => backInStockFallback.update(), delay));
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.planet-nusa-bis-trigger');
    if (!trigger) return;
    event.preventDefault();
    backInStockFallback.openModal(trigger);
  });
  document.addEventListener('theme:product:color-change', () => {
    [0, 500, 1500].forEach((delay) => window.setTimeout(() => backInStockFallback.update(), delay));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && backInStockFallback.modal && !backInStockFallback.modal.hidden) {
      backInStockFallback.closeModal();
    }
  });

  // Rebuy setup
  document.addEventListener("rebuy:smartcart.ready", (event) => {
  const cart = event.detail?.smartcart?.cart || event.detail?.cart?.cart || event.detail?.cart || null;

  addShippingInfo();
    addPaymentIcons();
  setTimeout(() => {
    addSiblingColorSwatches();
  }, 100);
    
  // Run every 100ms
  setInterval(addSiblingColorSwatches, 500);
});

// Smart Cart Change (handles add, remove, quantity changes, etc.)
document.addEventListener("rebuy:cart.change", (event) => {
  const cart = event.detail?.smartcart?.cart || event.detail?.cart?.cart || event.detail?.cart || null;

  addShippingInfo();
  addPaymentIcons();

  setTimeout(() => {
    addSiblingColorSwatches();
  }, 100);

  // make sure the "Total" span gets text content when the rebuy cart is ready after changing
  const totalElement = document.querySelector('.rebuy_total_amount_div .rebuy_total_text');
  if (totalElement) {
    totalElement.textContent = window.theme.strings.orderTotal;
  }
})

function addPaymentIcons() {
  setTimeout(() => {
    const paymentIcons = document.querySelector(
      "ul.cart__drawer__payment__icons"
    );
    const checkoutArea = document.querySelector(
      'div[data-rebuy-component="checkout-area"]'
    );

    if (checkoutArea && paymentIcons) {
      const existingPaymentIcons = checkoutArea.querySelector(
        "ul.cart__drawer__payment__icons"
      );
      if (existingPaymentIcons) {
        existingPaymentIcons.remove();
      }

      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      checkoutArea.appendChild(clonedPaymentIcons);
    }
  }, 500);
}

function addSiblingColorSwatches() {
  // Find all color variant containers in the Rebuy cart
  const rebuyVariantsWithoutSwatches = [...document
    .querySelectorAll('.rebuy-cart__flyout-item-variant--color')]
    .filter(variant => !variant.querySelector('.cart__item__variant-swatches'));
  
  if (rebuyVariantsWithoutSwatches.length > 0) {
    rebuyVariantsWithoutSwatches.forEach((rebuyVariant, index) => {
      // Find the Rebuy cart item to get product information
      const rebuyItem = rebuyVariant.closest('.rebuy-cart__flyout-item');
      if (!rebuyItem) {
        console.warn('No rebuy item found for variant', index);
        return;
      }
      
      // Get the product title
      const rebuyProductTitle = rebuyItem.querySelector('.rebuy-cart__flyout-item-product-title')?.textContent?.trim();
      
      if (!rebuyProductTitle) {
        console.warn('No product title found for rebuy item', index);
        return;
      }
      
      // Create swatches container
      const swatchesContainer = document.createElement('div');
      swatchesContainer.className = 'cart__item__variant-swatches';
      
      // Try to find the main cart item with the same product title to get the swatches
      const themeCartItems = document.querySelectorAll('.cart__item');
      let matchingThemeCartItem = null;
      
      for (const themeCartItem of themeCartItems) {
        const mainCartTitle = themeCartItem.querySelector('.cart__item__title a')?.textContent?.trim();
        if (mainCartTitle === rebuyProductTitle) {
          matchingThemeCartItem = themeCartItem;
          break;
        }
      }
      
      if (matchingThemeCartItem) {
        const mainCartSwatches = matchingThemeCartItem.querySelector('.cart__item__variant-swatches');

        if (mainCartSwatches) {
          const clonedSwatches = mainCartSwatches.cloneNode(true);
          swatchesContainer.appendChild(clonedSwatches);
          rebuyVariant.appendChild(swatchesContainer);
        }
      } else {
        console.warn(`${rebuyProductTitle} - Has no matching main cart item`);
      }
    });
  }
}


function addShippingInfo() {
  setTimeout(() => {
    const estimatedDelivery = document.querySelector(".estimated-delivery");

    if (!estimatedDelivery) {
      return;
    }
    const cartFooter = document.querySelector(
      'div[data-rebuy-cart-anchor="footer"]'
    );

    if (!cartFooter) {
      return;
    }

    const existingEstimatedDelivery = cartFooter.querySelector(
      ".estimated-delivery"
    );
    if (
      existingEstimatedDelivery &&
      existingEstimatedDelivery !== estimatedDelivery
    ) {
      existingEstimatedDelivery.remove();
    }

    const cartSubtotal = cartFooter.querySelector(
      'div[data-rebuy-component="cart-subtotal"]'
    );

    const checkoutArea = cartFooter.querySelector(
      'div[data-rebuy-component="checkout-area"]'
    );
    const clonedEstimatedDelivery = estimatedDelivery.cloneNode(true);
    if (checkoutArea && cartSubtotal) {
      checkoutArea.insertAdjacentElement(
        "beforebegin",
        clonedEstimatedDelivery
      );
    } else if (cartSubtotal) {
      cartSubtotal.insertAdjacentElement("afterend", clonedEstimatedDelivery);
    } else {
      cartFooter.appendChild(clonedEstimatedDelivery);
    }
  }, 500);
}

addShippingInfo();

const currencySymbols = {
  'kr': 'kr',
  'dkk': 'kr',
  "DKK": "kr",
  "EUR": "€",
  "USD": "$",
  "GBP": "£"
};

// Helper function to format currency like Rebuy does
function formatCurrency(amountInCents, currency) {
  const amount = amountInCents / 100;
  
  const symbol = currencySymbols[currency] || currency;
  
  if (currency === 'DKK' || currency === 'dkk' || currency === 'kr') {
    return `${symbol} ${amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  } else {
    return `${symbol}${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

function getMarketHandle() {
  const country = Shopify.country.toLowerCase();
  
  const marketMap = {
    'dk': 'denmark',
    'us': 'usa',
    'gb': 'uk',
    'eu': 'europe',
  }

  return marketMap[country] || 'denmark'; // Default to denmark instead of 'en'
}

// Helper function to get cart data from multiple sources
function getCartData(providedCart = null) {
  let subtotalPrice = 0;
  
  // Try provided cart first
  if (providedCart?.items_subtotal_price) {
    subtotalPrice = providedCart.items_subtotal_price;
    return subtotalPrice;
  }
  
  // Try rebuy cart
  if (window.rebuyCart?.cart?.items_subtotal_price) {
    subtotalPrice = window.rebuyCart.cart.items_subtotal_price;
    return subtotalPrice;
  }
  
  // Try Shopify cart
  if (typeof Shopify !== 'undefined' && Shopify.cart?.total_price) {
    subtotalPrice = Shopify.cart.total_price;
    return subtotalPrice;
  }
  
  return 0;
}

if (!window.planetNusaColorNavigation) {
  window.planetNusaColorNavigation = true;
  let colorRequest;

  const getSwatchKey = (link) => new URL(link.href, window.location.origin).pathname;

  const reorderSwatches = (component, order, visibleLimit, keepExpanded) => {
    const container = component.querySelector('[data-variant-buttons]');
    if (!container) return;

    const toggle = container.querySelector('show-color-swatches');
    const links = Array.from(container.querySelectorAll('[data-product-color-link]'));
    const positions = new Map(order.map((key, index) => [key, index]));
    links.sort((first, second) => {
      const firstPosition = positions.get(getSwatchKey(first)) ?? Number.MAX_SAFE_INTEGER;
      const secondPosition = positions.get(getSwatchKey(second)) ?? Number.MAX_SAFE_INTEGER;
      return firstPosition - secondPosition;
    });
    links.forEach((link, index) => {
      const isExtra = index >= visibleLimit;
      link.classList.toggle('is-extra', isExtra);
      if (isExtra && !keepExpanded && link.getAttribute('aria-current') !== 'page') {
        link.setAttribute('hidden', '');
      } else {
        link.removeAttribute('hidden');
      }
      container.insertBefore(link, toggle);
    });
  };

  const expandSwatchGroup = (component) => {
    const container = component.querySelector('[data-variant-buttons]');
    if (!container) return;

    container.querySelectorAll('[data-product-color-link].is-extra').forEach((swatch) => {
      swatch.removeAttribute('hidden');
    });
    container.classList.add('is-expanded');

    const toggle = container.querySelector('.color-swatch__show-more');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  };

  const preserveShippingInfo = (currentComponent, nextComponent) => {
    const currentShippingInfo = currentComponent.querySelector('shipping-info');
    const nextShippingInfo = nextComponent.querySelector('shipping-info');
    if (!currentShippingInfo || !nextShippingInfo) return;

    nextShippingInfo.innerHTML = currentShippingInfo.innerHTML;
  };

  const navigateToColor = async (link) => {
    const currentComponent = link.closest('product-component');
    if (!currentComponent || link.getAttribute('aria-current') === 'page') return;

    const sectionId = currentComponent.dataset.sectionId;
    const targetUrl = new URL(link.href, window.location.origin);
    const requestUrl = new URL(targetUrl.href);
    requestUrl.searchParams.set('section_id', sectionId);
    const currentSwatchContainer = link.closest('[data-variant-buttons]');
    const keepExpanded = currentSwatchContainer?.classList.contains('is-expanded') || false;
    const currentSwatches = Array.from(currentSwatchContainer.querySelectorAll('[data-product-color-link]'));
    const swatchOrder = currentSwatches.map(getSwatchKey);
    const firstExtraIndex = currentSwatches.findIndex((swatch) => swatch.classList.contains('is-extra'));
    const visibleLimit = firstExtraIndex === -1 ? currentSwatches.length : firstExtraIndex;

    colorRequest?.abort();
    colorRequest = new AbortController();
    currentComponent.setAttribute('aria-busy', 'true');
    link.classList.add('is-loading');

    try {
      const response = await fetch(requestUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: colorRequest.signal
      });
      if (!response.ok) throw new Error(`Product request failed: ${response.status}`);

      const responseText = await response.text();
      const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
      const nextComponent = responseDocument.querySelector('product-component');
      if (!nextComponent) throw new Error('Product section was missing from the response');
      preserveShippingInfo(currentComponent, nextComponent);
      reorderSwatches(nextComponent, swatchOrder, visibleLimit, keepExpanded);
      window.history.pushState({ productColorUrl: targetUrl.href }, '', targetUrl.href);

      const update = () => {
        currentComponent.innerHTML = nextComponent.innerHTML;
        Array.from(nextComponent.attributes).forEach((attribute) => {
          currentComponent.setAttribute(attribute.name, attribute.value);
        });
        currentComponent.formWrapper = currentComponent.querySelector('[data-form-wrapper]');
        currentComponent.form = currentComponent.querySelector('[data-product-form]');
        currentComponent.cartBar = currentComponent.querySelector('#cart-bar');
        if (currentComponent.cartBar) currentComponent.initCartBar();
      };
      if (document.startViewTransition) {
        await document.startViewTransition(update).finished;
      } else {
        update();
      }

      if (keepExpanded) expandSwatchGroup(currentComponent);
      window.requestAnimationFrame(() => window.planetNusaEnableBackInStock?.());
      document.dispatchEvent(new CustomEvent('theme:product:color-change', {
        detail: { url: targetUrl.href, sectionId }
      }));
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(targetUrl.href);
    } finally {
      const activeComponent = document.querySelector(`#Product--${CSS.escape(sectionId)}`);
      activeComponent?.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-color-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigateToColor(link);
  });

  window.addEventListener('popstate', () => {
    window.location.reload();
  });
}

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
